import { createContext, useContext, ReactNode } from 'react';
import {
  useSimulationState,
  SimulationStateReturn,
} from './useSimulationState';

const SimulationContext = createContext<SimulationStateReturn | null>(null);

export function SimulationContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const state = useSimulationState();
  return (
    <SimulationContext.Provider value={state}>
      {children}
    </SimulationContext.Provider>
  );
}

export function useSimulation(): SimulationStateReturn {
  const ctx = useContext(SimulationContext);
  if (!ctx)
    throw new Error(
      'useSimulation must be used within SimulationContextProvider',
    );
  return ctx;
}
